import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {
    Tabs,
  } from "@material-ui/core";
const StyledTabs = withStyles({
    indicator: {
      display: "flex",
      justifyContent: "center",
      backgroundColor: "#245144",
      "& > div": {
        width: 0,
        height: 0,
        borderLeft: "10px solid transparent",
        borderRight: "10px solid transparent",
        borderBottom: "10px solid #245144",
        top: "-10px",
        left: "45%",
        position: "absolute",
      },
    },
  })((props) => (
    <Tabs
      style={{ backgroundColor: "#fff", paddingBottom: "1%" }}
      {...props}
      TabIndicatorProps={{ children: <div /> }}
    />
  ));

export default StyledTabs